module.exports = __webpack_public_path__ + "b67b7cf6d2530f3c0bca595b53501680.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_edit_icon_2x.png
// module id = 120
// module chunks = 0 1 2 3 4